import type { SelectAttribute } from '../../../../types/SelectAttribute';

import {
  prefectures,
  isPrefectureId as orgIsPrefectureId,
  type PrefectureId as OrgPrefectureId,
} from '@/packages/nurse-senka-frontend-sdk';

const prefectureAttributes: SelectAttribute[] = prefectures.map(
  (value, index) => ({
    key: index,
    value: String(value.id),
    label: value.label,
  }),
);

export const createPrefectureAttributes = (): SelectAttribute[] =>
  prefectureAttributes;

export type PrefectureId = OrgPrefectureId;

export const isPrefectureId = orgIsPrefectureId;
